import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';
import Grid from '@mui/material/Grid';
import MKInput from 'components/MKInput';
import MKButton from 'components/MKButton';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';

function SimpleContactCard({ title, description }) {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    jobRole: '',
    description: '',
  });

  const [checked, setChecked] = useState(false);
  const [sendButtonDisabled, setSendButtonDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({ open: false, message: '', severity: 'success' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCheckboxChange = (event) => {
    setChecked(event.target.checked);
    setSendButtonDisabled(!event.target.checked); // Enable send button when checkbox is checked
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!checked) {
      return;
    }
    setLoading(true);
    try {
      await axios.post('https://api.pwncat.com/api/v0/sendMessage', formData);
      setFormData({
        fullName: '',
        email: '',
        phone: '',
        jobRole: '',
        description: '',
      });
      setNotification({ open: true, message: '¡Mensaje enviado con éxito!', severity: 'success' });
    } catch (error) {
      setNotification({ open: true, message: 'Error al enviar el mensaje. Por favor, inténtelo de nuevo.', severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseNotification = () => {
    setNotification({ ...notification, open: false });
  };

  return (
    <MKBox
      bgColor="white"
      borderRadius="xl"
      shadow="lg"
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      <MKBox variant="gradient" bgColor="dark" coloredShadow="dark" borderRadius="lg" p={2} mx={2} mt={-3}>
        <MKTypography variant="h3" color="white" align="center">
          {title}
        </MKTypography>
      </MKBox>
      <MKBox p={3}>
        <MKTypography variant="body2" color="text" mb={3}>
          {description}
        </MKTypography>
        <MKBox width="100%" component="form" onSubmit={handleSubmit} autoComplete="off">
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <MKInput
                variant="standard"
                label="Nombre Completo"
                name="fullName"
                InputLabelProps={{ shrink: true }}
                fullWidth
                value={formData.fullName}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <MKInput
                type="email"
                variant="standard"
                label="Correo Electrónico"
                name="email"
                InputLabelProps={{ shrink: true }}
                fullWidth
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <MKInput
                variant="standard"
                label="Número de Teléfono"
                name="phone"
                InputLabelProps={{ shrink: true }}
                fullWidth
                value={formData.phone}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <MKInput
                variant="standard"
                label="Puesto de Trabajo"
                name="jobRole"
                InputLabelProps={{ shrink: true }}
                fullWidth
                value={formData.jobRole}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <MKInput
                variant="standard"
                label="¿En qué podemos ayudarte?"
                name="description"
                placeholder="Describe tu pregunta en al menos 100 caracteres"
                InputLabelProps={{ shrink: true }}
                multiline
                fullWidth
                rows={10}
                value={formData.description}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={<Checkbox checked={checked} onChange={handleCheckboxChange} />}
                label={<MKTypography variant="body2" color="text">Al marcar esta casilla, aceptas los términos y condiciones.</MKTypography>}
              />
            </Grid>
          </Grid>
          <Grid container item justifyContent="center" xs={12} mt={5} mb={2}>
            <MKButton type="submit" variant="gradient" color="dark" disabled={sendButtonDisabled || loading}> {/* Disable send button based on state */}
              {loading ? <CircularProgress size={24} color="inherit" /> : 'Enviar Mensaje'}
            </MKButton>
          </Grid>
        </MKBox>
      </MKBox>
      <Snackbar
        open={notification.open}
        autoHideDuration={3000} // 3 segundos
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }} // Centrado en la parte superior
      >
        <Alert onClose={handleCloseNotification} severity={notification.severity} sx={{ width: '100%' }}>
          {notification.message}
        </Alert>
      </Snackbar>
    </MKBox>
  );
}

SimpleContactCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default SimpleContactCard;